import React from 'react'

function Coordinates() {

  return (
    <div>
      <span className="content-title">Nous joindre</span>

      <div className="card-panel">
      <div className="row">
        <div className="col s6 m4 l5">
          <div className="valign-center"><i className="material-icons orange-color">phone</i>&nbsp;&nbsp;Par
            téléphone&nbsp;:&nbsp;
          </div>
        </div>
        <div className="col s6 m8 l7">
          <a className="blue-grey-text text-darken-2 truncate" href="tel:+33621570943"><b>06.21.57.09.43</b></a>
        </div>
      </div>

      <div className="row">
        <div className="col s6 m4 l5">
          <div className="valign-center"><i className="material-icons orange-color">email</i>&nbsp;&nbsp;Par
            e-mail&nbsp;:&nbsp;
          </div>
        </div>
        <div className="col s6 m8 l7">
          <a className="blue-grey-text text-darken-2 truncate"
             href="mailto:mouvyourbaudet@gmail.com"><b>mouvyourbaudet@gmail.com</b></a>
        </div>
      </div>

      <div className="row">
        <div className="col s6 m4 l5">
          <div className="valign-center"><i className="material-icons orange-color">location_on</i>&nbsp;&nbsp;Par
            courrier&nbsp;:
          </div>
        </div>
        <div className="col s6 m8 l7 blue-grey-text text-darken-2">
          <b>Mouv' your Baudet
            <br/>12 impasse Olivier de Serres<br/>86000 POITIERS</b>
        </div>
      </div>
      </div>

    </div>
  );

}

export default Coordinates;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/Coordinates.js
 **/